import React from 'react';
import Grid from '@mui/material/Unstable_Grid2'
import {Card, CardContent, Typography} from "@mui/material";
import zedka_painting from "../generated/paintings/zedka_painting.webp";
import zedka_drawing from "../generated/paintings/zedka_drawing.webp";
import arcencielgriffemetal_painting from "../generated/paintings/arcencielgriffemetal_painting.webp";
import arcencielgriffemetal_drawing from "../generated/paintings/arcencielgriffemetal_drawing.webp";
import cauchemarenoble_painting from "../generated/paintings/cauchemarenoble_painting.webp";
import cauchemarenoble_drawing from "../generated/paintings/cauchemarenoble_drawing.webp";
import gribouille_painting from "../generated/paintings/gribouille_painting.webp";
import gribouille_drawing from "../generated/paintings/gribouille_drawing.webp";
import phantomcauchemar_painting from "../generated/paintings/phantomcauchemar_painting.webp";
import phantomcauchemar_drawing from "../generated/paintings/phantomcauchemar_drawing.webp";
import pipivol_painting from "../generated/paintings/pipivol_painting.webp";
import pipivol_drawing from "../generated/paintings/pipivol_drawing.webp";
import gigagigaroimonstrevolcan_painting from "../generated/paintings/gigagigaroimonstrevolcan_painting.webp";
import gigagigaroimonstrevolcan_drawing from "../generated/paintings/gigagigaroimonstrevolcan_drawing.webp";
import jigadraufeuxxl_painting from "../generated/paintings/jigadraufeuxxl_painting.webp";
import jigadraufeuxxl_drawing from "../generated/paintings/jigadraufeuxxl_drawing.webp";
import roipikatu_painting from "../generated/paintings/roipikatu_painting.webp";
import roipikatu_drawing from "../generated/paintings/roipikatu_drawing.webp";
import roiplokilte_painting from "../generated/paintings/roiplokilte_painting.webp";
import roiplokilte_drawing from "../generated/paintings/roiplokilte_drawing.webp";
import PaintingSlider from "./PaintingSlider";


function Home() {
    return (
        <Grid container spacing={0} sx={{flexGrow: 0}}>
            <Grid xs={12}>
                <Card sx={{margin: "1rem", marginBottom:0}}>
                    <CardContent sx={{flex: '1 0 auto'}}>
                        <Typography component="div" variant="h2">
                            Sasha's imaginary Pokémons
                        </Typography>
                        <Typography variant="subtitle1" color="text.secondary" component="div">
                            Here we will tell the story behind our paintings. Meanwhile, please, take a
                            look at <a href="https://objkt.com/profile/banzaitokyo/created"> our profile
                            on Objkt.com
                        </a> </Typography>
                    </CardContent>
                </Card>
                <Typography variant="h1" gutterBottom>
                </Typography>
            </Grid>

            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Jigadraufeuxxl" painting_src={jigadraufeuxxl_painting} drawing_src={jigadraufeuxxl_drawing}/>
            </Grid>
            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Gigagigaroimonstrevolcan" painting_src={gigagigaroimonstrevolcan_painting}
                                drawing_src={gigagigaroimonstrevolcan_drawing}/>
            </Grid>

            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Roipikatu" painting_src={roipikatu_painting} drawing_src={roipikatu_drawing}/>
            </Grid>
            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Roiplokilte" painting_src={roiplokilte_painting}
                                drawing_src={roiplokilte_drawing}/>
            </Grid>

            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Zedka" painting_src={zedka_painting} drawing_src={zedka_drawing}/>
            </Grid>
            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Arcencielgriffemetal" painting_src={arcencielgriffemetal_painting}
                                drawing_src={arcencielgriffemetal_drawing}/>
            </Grid>

            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="CauchemareNoble" painting_src={cauchemarenoble_painting}
                                drawing_src={cauchemarenoble_drawing}/>
            </Grid>
            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Gribouille" painting_src={gribouille_painting} drawing_src={gribouille_drawing}/>
            </Grid>

            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Phantomcauchemar" painting_src={phantomcauchemar_painting}
                                drawing_src={phantomcauchemar_drawing}/>
            </Grid>
            <Grid xs={12} sm={6} sx={{padding: '1rem'}}>
                <PaintingSlider title="Pipivol" painting_src={pipivol_painting} drawing_src={pipivol_drawing}/>
            </Grid>

        </Grid>
    );
}

export default Home;